import { IZone } from 'app/shared/model//zone.model';
import { IEvent } from 'app/shared/model//event.model';

export const enum TicketType {
  PUBLIC = 'PUBLIC',
  CONSIGNMENT = 'CONSIGNMENT',
  COMPLEMENTARY = 'COMPLEMENTARY',
  DISCOUNT = 'DISCOUNT',
  PRIORITY_BOOKING = 'PRIORITY_BOOKING'
}

export interface IPricing {
  id?: number;
  price?: number;
  handlingFee?: number;
  insideCharge?: number;
  remark?: string;
  ticketType?: TicketType;
  zone?: IZone;
  event?: IEvent;
}

export const defaultValue: Readonly<IPricing> = {};
